import Aos from "../components/aos";
/**
 * Front Page
 */
const PageFrontPage = ($) => {
	if ($("body").hasClass("home")) {
		Aos();
	}
};

export default PageFrontPage;
